import React from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Main } from "../views/Main/Main";
import ChangePassword from "../views/changePassword/ChangePassword";
import NotFound from "../components/NotFound";
import TopMenu from "../components/common/TopMenu";
import BottomMenu from "../components/common/BottomMenu";
import Account from "../views/account/Account";
import { AdminRouteWrapper } from "./AdminRouteWrapper";
import { useViewport } from "../helpers";
import MyDesign from "../views/myDesign/MyDesign";
import ValidateAccount from "../views/account/ValidateAccount";
import ValidateEmail from "../views/account/ValidateEmail";
import Schedule from "../views/myDesign/zones/Schedule";
import { useSelector } from "react-redux";
import GlobalStatistics from "../views/statistics/GlobalStatistics";
import MyDesigns from "../views/myDesigns/MyDesigns";
import MyExpariences from "../views/myExpariences/MyExpariences";
import { AdminDmaHome } from "../views/adminDmaHome/AdminDmaHome";
import Upload from "../views/uploadMultipleZones/Upload";
import ScheduleMultipleZones from "../views/scheduleMultipleZones/ScheduleMultipleZones";
import AssociateEmail from "../views/account/AssociateEmail";
import ZoneManager from "../views/myDesign/zones/ZoneManager";
import UserDashboard from "../views/dashboard/UserDashboard";
import AccountMobile from "../views/account/AccountMobile";
import { AdminUsers } from "../views/adminUsers/AdminUsers";
import { PaymentsDashboard } from "../views/paymentsDashboard/PaymentsDashboard";
import { AdminEntities } from "../views/adminEntities/AdminEntities";
import { AdminJourneys } from "../views/adminJourneys/AdminJourneys";
import CampaignManagement from "../views/campaignManagement/CampaignManagement";
import Categories from "../views/categories/Categories";
import MyExparienceManager from "../views/myExparience/MyExparienceManager";
import CreateExparienceManager from "../views/myExparience/createExparience/CreateExparienceManager";
import WebviewAr from "../views/webviewAr/WebviewAr";
import MyExpariencesWithPreAuthentication from "../views/myExpariences/MyExpariencesWithPreAuthentication";
import MyGlobeWithPreAuthentication from "../views/myExpariences/MyGlobeWithPreAuthentication";
import MyMobileGlobe from "../views/myGlobe/MyGlobeView";
import { PrivateRouteWrapper } from "./PrivateRouteWrapper";
import BackdropManager from "../components/backdrop/BackdropManager";
import ConditionsDisplayer from "../components/conditionsDisplayer/ConditionsDisplayer";
import HdrManager from "../components/hdrManager/HdrManager";
import QRCodeManagement from "../components/qrCodeManagement/QrCodeManagement";
import GameLeaderboards from "../views/myExparience/statistics/GameLeaderboards";
import PurchaseGeoloc from "../views/purchaseGeoloc/PurchaseGeoloc";
import ClassesManagement from "../views/classManagement/ClassesManagement";
import PaymentStatus from "../components/purchaseGeoloc/PaymentStatus";
import ComponentsManagement from "../views/modelsManagement/ComponentsManagement";
import PurchaseGeolocExparienceOverview from "../views/PurchasedGeolocExparienceOverview.jsx/PurchasedGeolocExparienceOverview";
import GeolocalisedExpariences from "../views/geolocalisedExpariences/GeolocalisedExpariences";

function AppContent({ loggedIn, width }) {
  const location = useLocation();
  // Masquer les menus sur la route /purchase-geoloc (ou /purchase-geoloc/:id)
  const hideMenus = location.pathname.startsWith("/purchase-geoloc");

  return (
    <>
      <BackdropManager />
      <div className="App">
        {loggedIn && !hideMenus && <TopMenu />}
        <Routes>
          <Route path={"/"} element={<Main />} />
          <Route path="/admin/" element={<AdminRouteWrapper />}>
            <Route path="dma/page" element={<AdminDmaHome />} />
            <Route path="QRcodes" element={<QRCodeManagement />} />
            <Route path="hdr" element={<HdrManager />} />
            <Route path="models" element={<ComponentsManagement />} />
            <Route path="campaigns" element={<CampaignManagement />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="payments" element={<PaymentsDashboard />} />
            <Route path="entities" element={<AdminEntities />} />
            <Route path="journeys" element={<AdminJourneys />} />
            <Route path="categories" element={<Categories />} />
          </Route>
          <Route path="/" element={<PrivateRouteWrapper />}>
            <Route path="/classes" element={<ClassesManagement />} />
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route path="/myDesigns" element={<MyDesigns />} />
            <Route path="/m/statistics" element={<MyMobileGlobe />} />
            <Route path="/myExpariences" element={<MyExpariences />} />
            <Route
              path="/myExpariences/create"
              element={<CreateExparienceManager />}
            />
            <Route
              path="/myExpariences/:id"
              element={<MyExparienceManager />}
            />
            <Route
              path="/myExpariences/:id/:section"
              element={<MyExparienceManager />}
            />
            <Route path="/account" element={<Account />} />
            <Route
              path="/accounts/validate-email/:key"
              element={<ValidateEmail />}
            />
            <Route
              path="/account/associate/:key"
              element={<AssociateEmail />}
            />
            <Route path="/mydesign/:id" element={<MyDesign />} />
            <Route
              path="/mydesign/:id/zone/:idZone"
              element={<ZoneManager />}
            />
            <Route
              path="/mydesign/:id/:targetLabel/:index/schedule"
              element={<Schedule />}
            />
            <Route path="/upload" element={<Upload />} />
            <Route path="/schedule" element={<ScheduleMultipleZones />} />
            <Route path="/statistics" element={<GlobalStatistics optimize />} />
          </Route>
          <Route path="/login" element={<Main />} />
          <Route path="/register" element={<Main />} />
          <Route path="/auth/:provider/callback" element={<Main />} />
          <Route
            path="/myExpariences/mobile/:iv/:content"
            element={<MyExpariencesWithPreAuthentication />}
          />
          <Route
            path="/m/statistics/:iv/:content"
            element={<MyGlobeWithPreAuthentication />}
          />
          <Route
            path="/account/mobile/:iv/:content"
            element={<AccountMobile />}
          />
          <Route path="/webview" element={<WebviewAr />} />
          <Route
            path="/leaderboard"
            element={<GameLeaderboards standalone />}
          />
          <Route path="/auth/validate/:key" element={<ValidateAccount />} />
          <Route path="/account/validate/:key" element={<ValidateAccount />} />
          <Route path="/reset-password/:key" element={<ChangePassword />} />
          <Route
            path="/termsofuse"
            element={<ConditionsDisplayer conditionName="cgu" />}
          />
          <Route
            path="/dataprotection"
            element={<ConditionsDisplayer conditionName="pc" />}
          />
          <Route
            path="/salesconditions"
            element={<ConditionsDisplayer conditionName="cgv" />}
          />
          <Route
            path="/purchased-geoloc/:id/"
            element={<PurchaseGeolocExparienceOverview />}
          />
          <Route path="/purchase-geoloc/:id/" element={<PurchaseGeoloc />} />
          <Route
            path="/purchased-geoloc"
            element={<GeolocalisedExpariences bought />}
          />
          <Route
            path="/geolocalised-expariences"
            element={<GeolocalisedExpariences />}
          />
          <Route
            path="/purchase-geoloc/:id/success"
            element={<PaymentStatus success />}
          />
          <Route
            path="/purchase-geoloc/:id/cancel"
            element={<PaymentStatus cancel />}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        {width <= 768 && !hideMenus && <BottomMenu />}
      </div>
    </>
  );
}

function AppRoutes() {
  const { width } = useViewport();
  const loggedIn = useSelector((state) => state.user.loggedIn);

  return (
    <BrowserRouter>
      <AppContent loggedIn={loggedIn} width={width} />
    </BrowserRouter>
  );
}

export { AppRoutes };
